export default __webpack_public_path__ + "static/media/WAS0333.34I-41667_-24935_0.113637dc.jpg";